module.exports = __webpack_public_path__ + "img/logo-democratie-in-actie.a91f7b2b.png";